<template>
<div class="section">
  <div class="section__header">
    <h2>Анкета ученика</h2>
    <back></back>

		<div v-if="item" class="student__info">
			<h3 class="student__name">{{ item.name }}, <span v-if="item.age > 0">{{ item.age }} лет</span></h3>
      
			<p class="student__desc" v-if="sclass">
				<span>Логин:</span> {{ item.email }},
				<span>Класс:</span> <router-link class="class__link" :to="'/class/' + sclass.id">{{sclass.title}}</router-link> <br>
				<span>Баллов:</span> {{ item.scores }},
				<span>Статус:</span> {{ item.status ? item.status.title : '-' }}
			</p>

      <small class="student__login">Заходил: {{ item.last_login }}</small>
		</div>		

    <div class="section__menu header-menu">
      <button 
				type="button" 
				class="header-menu__btn" 
				@click="openPopup('StudentAnketa', item)"
			>
        <i class="fas fa-edit"></i>
        Редактировать
      </button>

			<button 
				type="button" 
				class="header-menu__btn" 
				@click="refreshStatus"
			>
        <i class="fas fa-redo"></i>
        Статус
      </button>

			<button 
				type="button" 
				class="header-menu__btn" 
				@click="recountScores"
			>
        <i class="fas fa-redo"></i>
        Баллы
      </button>
    </div>

    <div class="section__tabs">
      <button 
        class="header-menu__btn header-menu__btn--tab"
        @click="currentTab = 'stat'"
        :class="{active: currentTab === 'stat'}"
      >
        Статистика
      </button>

      <!-- <button 
        class="header-menu__btn header-menu__btn--tab"
        @click="currentTab = 'feedback'"
        :class="{active: currentTab === 'feedback'}"
      >
        Обратная связь
      </button> -->

      <button 
        class="header-menu__btn header-menu__btn--tab"
        @click="currentTab = 'rating'"
        :class="{active: currentTab === 'rating'}"
      >
        Рейтинг
      </button>
    </div>
  </div>	

	<div class="section__body" v-if="item">
		<div class="section__tab" v-if="currentTab === 'stat'">
      <StatBody class="statistics" :student="item" />
    </div>

		<div class="section__tab" v-if="currentTab === 'feedback'">
			<div>
        <date-picker 
          :range="true" 
          :format="'DD-MM-YYYY'" 
          v-model="dates" 
          valueType="format" 
          :placeholder="'Диапазон дат'"
          @input="getReports"
        ></date-picker>
      </div>
      <div class="myclass__link uk-margin-small-top" v-if="!show_add_report">
        <a href="#" @click.prevent="openPopup('Feedback', item)">+ Добавить обратную связь для родителей</a>
      </div>

      <ul uk-accordion v-if="reports.length" class="myclass__accord">
        <FeedbackItem v-for="(item, i) in reports" :item="item" :key="i" />
      </ul>
      <span v-else>Обратная связь не найдена</span>
		</div>

		<div class="section__tab" v-if="currentTab === 'rating'">
			<RatingTable class="rating-table" v-if="item && item.status" :student="item" />
      <p v-else>Еще не в рейтинге</p>
		</div>
	</div>

	<Popup :isOpened="popupIsOpened" @close="popupIsOpened = false">
    <template v-slot:content>
      <component 
        :is="popupContent" 
        :data="popupData" 
        :moveStudent="true"
        @close-popup="popupIsOpened = false"
				@update-student="updateStudent"
      ></component>
    </template>
  </Popup>
</div>
</template>

<script>
import StatBody from '../../stats/StatBody'
import Feedback from '../classes/Feedback'
import moment from "moment";
import RatingTable from "../../student/RatingTable";
import StudentAnketa from "./StudentAnketa";
import FeedbackItem from '../classes/FeedbackItem'
import { mapGetters, mapMutations } from 'vuex'
import { popup_mix } from '../../../mixins/popup_mix'

export default {
  name: "student",
  inject: ['http'],
	mixins: [ popup_mix ],
  components: {
    StatBody,
    RatingTable,
    StudentAnketa,
    FeedbackItem,
    Feedback
  },
  data() {
    return {
			currentTab: 'stat',
      show_add_report: false,
      dates: null,
      reports: []
    }
  },
  computed: {
    ...mapGetters({
      studentById: 'teacher/studentById'
    }),
    item() {
      return this.studentById(this.$route.params.id)
    },
    sclass() {
      let item = this.item;
      if (item.class) {
        return item.class;
      }
    }
  },
  methods: {
    ...mapMutations({
      updateStudent: 'teacher/updateStudent'
    }),
    formatDate(date) {
      return moment(date, 'YYYY-MM-DD HH:mm:ss').format('DD MMMM YYYY');
    },
    getReports() {
      let data = {
        id: this.$route.params.id,
        dates: this.dates
      }
			this.http.post('onGetFilteredOS', data).then(res => {
				this.reports = res.data
			})
    },
		refreshStatus() {
      let data = {
        'user_id': this.item.id
      }
      this.http.post('onRefreshStatus', data).then((res) => {
        if (res.data.status) {
					this.item.status = res.data.status
				};
        if (res.data.message) {
					swal('Успешно!', res.data.message, "success");
				}
      });
    },
    recountScores() {
      let data = {
        'user_id': this.item.id
      }
      this.http.post('onRecountScores', data).then((res) => {
        if (res.data.scores) {
					this.item.scores = res.data.scores;
				} 
        if (res.data.message) {
					swal('Успешно!', res.data.message, "success");
				} 	
      })
    }
  },
  mounted() {
    if (this.item) {
      this.reports = this.item.student_reports
    }
    moment.locale('ru');
  },
  watch: {
    item() {
      this.reports = this.item.student_reports
      console.log(this.item)
    }
  }
}
</script>

<style lang="scss" scoped>
.uk-button-primary {
  padding: 6px 12px;
  margin-left: 10px;
}
.student__info {
	text-align: center;
	margin-top: 20px;
}
.student__desc {
	margin: 0;
	font-size: 13px;

	& span {
		font-weight: bolder;
	}
}

.class__link {
	color: #1e87f0;

	&:hover {
		text-decoration: underline;
	}
}

.section__tabs {
  margin-top: 20px;
}

.rating-table {
  width: 100%;
  max-width: 600px;
}

.statistics {
  box-sizing: border-box;
  width: 100%;
}

.student__login {
  color: #999999;
}
</style>
